import { FC, PropsWithChildren } from "react";
import { App as AntApp, ConfigProvider } from "antd";

import { ThemeConfig } from "antd/es/config-provider";

export const colors = {
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  GREY: "#999999",
  DISABLE_GREY: "#575F4D",
  LIGHT_GREY: "#CCCCCC",
  RED: "#BF242B",
  BLUE: "#418DE7",
  SURFACE1: "#F7F7F7",
  GREEN: "#00865A",
  ICON_INACTIVE: "#808080",
} as const;

const theme: ThemeConfig = {
  inherit: false,
  hashed: false,
  token: {
    fontFamily: "KevinMurphy, Arial, sans-serif",
    colorPrimary: colors.BLACK,
    colorError: colors.RED,
    colorText: colors.BLACK,
    blue: colors.BLUE,
  },
  components: {
    Menu: {
      padding: 0,
      colorBorderBg: "unset",
      colorActiveBarHeight: 0,
      colorPrimaryBg: "unset",
      itemActiveBg: "unset",
      itemSelectedBg: colors.LIGHT_GREY,
    },
    Layout: {
      headerPadding: "0 32px",
      headerHeight: "80px",
      colorBgLayout: "unset",
      headerBg: "unset",
      bodyBg: "unset",
      siderBg: "unset",
    },
    Typography: {
      fontSize: 16,
      fontSizeHeading2: 38,
    },
    Form: {
      lineHeight: 1.2,
      labelFontSize: 12,
      itemMarginBottom: 32,
      labelHeight: "auto",
      verticalLabelMargin: "0 0 14px 0",
      verticalLabelPadding: 0,
      labelColonMarginInlineStart: 0,
      labelColonMarginInlineEnd: 0,
    },
    Input: {
      lineWidth: 1,
      lineHeight: 1.5,
      borderRadius: 0,
      colorBorder: colors.BLACK,
      activeBorderColor: colors.BLACK,
      hoverBorderColor: colors.BLACK,
      activeShadow: "none",
      warningActiveShadow: "none",
      errorActiveShadow: "none",
      paddingBlock: 8,
      paddingInline: 1,
      colorTextPlaceholder: colors.GREY,
      colorTextDisabled: colors.DISABLE_GREY,
      colorBgContainerDisabled: colors.WHITE,
    },
    Button: {
      borderRadius: 0,
      contentLineHeight: 1.714,
      fontWeight: 700,
      paddingBlock: 6,
      paddingInline: 24,
      controlHeight: 44,
      primaryShadow: "none",
      textHoverBg: "none",
      colorBgTextActive: "none",
      colorTextDisabled: colors.WHITE,
      colorBgContainerDisabled: colors.LIGHT_GREY,
      defaultBorderColor: colors.BLACK,
    },
    Select: {
      borderRadius: 0,
      colorBorder: colors.BLACK,
      colorText: colors.BLACK,
      optionSelectedBg: colors.WHITE,
      optionActiveBg: colors.WHITE,
      optionSelectedFontWeight: 500,
      optionLineHeight: 1.5,
      optionPadding: "6px 8px",
      showArrowPaddingInlineEnd: 18,
    },
    Radio: {
      buttonCheckedBg: colors.SURFACE1,
    },
    Table: {
      lineHeight: 1.5,
      borderRadius: 0,
      headerBorderRadius: 0,
      cellPaddingBlockSM: 0,
      cellPaddingInlineSM: 16,
      rowSelectedBg: colors.SURFACE1,
      rowSelectedHoverBg: colors.SURFACE1,
      borderColor: colors.LIGHT_GREY,
      bodySortBg: colors.WHITE,
      headerSortActiveBg: colors.WHITE,
    },
  },
};

export const AntProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConfigProvider theme={theme} wave={{ disabled: true }}>
      <AntApp>{children}</AntApp>
    </ConfigProvider>
  );
};
